














import { defineComponent, computed, useFetch } from '~/utils/nuxt3-migration'
import { useI18n } from '~/compositions/i18n'
import { ciHome } from '~/icons/source/light/home'
import { ciHome as ciHomeSolid } from '~/icons/source/solid/home'
import { BottomMenuItem } from '~/models/header/bottom-menu-item'
import MobileBottomMenuItem from '~/components/car/header/MobileBottomMenuItem.vue'
import { ciParking } from '~/icons/source/light/parking'
import { ciParking as ciParkingSolid } from '~/icons/source/solid/parking'
import { ciSavedSearch } from '~/icons/source/light/saved-search'
import { ciSavedSearch as ciSavedSearchSolid } from '~/icons/source/solid/saved-search'
import { ciNotifications } from '~/icons/source/light/notifications'
import { ciNotifications as ciNotificationsSolid } from '~/icons/source/solid/notifications'
import { ciUserCircle } from '~/icons/source/light/user-circle'
import { ciUserCircle as ciUserCircleSolid } from '~/icons/source/solid/user-circle'
import { ciMyClassifieds } from '~/icons/source/light/my-classifieds'
import { ciMyClassifieds as ciMyClassifiedsSolid } from '~/icons/source/solid/my-classifieds'
import { ciAudit } from '~/icons/source/light/audit'
import { ciAudit as ciAuditSolid } from '~/icons/source/solid/audit'
import { ciAuditRequest } from '~/icons/source/light/audit-request'
import { ciAuditRequest as ciAuditRequestSolid } from '~/icons/source/solid/audit-request'
import { ciGlobe } from '~/icons/source/light/globe'
import { ciGlobe as ciGlobeSolid } from '~/icons/source/solid/globe'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { defineComponentTranslations } from '~/utils/i18n'
import { useGlobalElements } from '~/compositions/global-elements'

export default defineComponent({
  components: { MobileBottomMenuItem },
  setup() {
    const { t } = useI18n()

    const { dispatch: pageDispatch } = useNamespacedStore(PAGE_NS)
    const { getters: userGetters, state: userState } = useNamespacedStore<
      UserState
    >(USER_NS)
    const isSingleOrAnon = computed(() => userGetters('isSingleOrAnon'))
    const isSingle = computed(() => userGetters('isSingle'))
    const isAuditsUser = computed(() => userGetters('isAuditsUser'))
    const isAdmin = computed(() => userGetters('isAdmin'))
    const auditRequestsCount = computed(() => userState.auditRequestsCount)
    const username = computed(() => userState.username)
    const unreadNotifications = computed(() => userState.unreadNotifications)

    const { showAccountIndicator } = useGlobalElements()

    useFetch(async () => {
      await pageDispatch('addBodyClass', 'has-bottom-menu')
    })

    const bottomMenuItems = computed<BottomMenuItem[]>(() => {
      return [
        {
          title: t('home::breadcrumbs'),
          to: { name: '__index' },
          icon: ciHome,
          activeIcon: ciHomeSolid
        },
        {
          title: t('searches'),
          to: {
            name: isSingleOrAnon.value ? '__searches' : '__account_searches'
          },
          icon: ciSavedSearch,
          activeIcon: ciSavedSearchSolid,
          hide: isAuditsUser.value
        },
        {
          title: 'Parking',
          to: {
            name: isSingleOrAnon.value ? '__parking' : '__account_parking'
          },
          icon: ciParking,
          activeIcon: ciParkingSolid,
          hide: isAuditsUser.value
        },
        {
          title: t('audits::elegxoi'),
          to: { name: '__account_audits_external_certificates' },
          icon: ciAudit,
          activeIcon: ciAuditSolid,
          hide: !isAuditsUser.value
        },
        {
          title: t('audit_requests_sm'),
          to: { name: '__account_audits_requests' },
          icon: ciAuditRequest,
          activeIcon: ciAuditRequestSolid,
          hasIndicator: Boolean(auditRequestsCount.value),
          hide: !isAuditsUser.value
        },
        {
          title: t('notifications'),
          to: { name: '__account_notifications' },
          icon: ciNotifications,
          activeIcon: ciNotificationsSolid,
          hasIndicator: unreadNotifications.value > 0
        },
        {
          title: isSingle.value ? t('my_classified_short') : t('profile'),
          to: isSingle.value
            ? {
                name: '__classifieds_view',
                params: { slugOrId: username.value }
              }
            : { name: '__account' },
          icon: isSingle.value ? ciMyClassifieds : ciUserCircle,
          activeIcon: isSingle.value ? ciMyClassifiedsSolid : ciUserCircleSolid,
          hasIndicator: showAccountIndicator.value,
          hide: isAdmin.value
        },
        {
          title: 'Admin',
          to: { name: '__admin' },
          icon: ciGlobe,
          activeIcon: ciGlobeSolid,
          hide: !isAdmin.value
        }
      ]
    })

    return { bottomMenuItems, ciMyClassifieds }
  },
  i18n: defineComponentTranslations({
    my_classified_short: {
      en: 'My Classified',
      el: 'Αγγελία μου'
    }
  })
})
